<template>
  <div class="party-activity-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('partyActivity.list.title') }}</span>
        <el-button type="primary" size="small" @click="_openAddDialog">
          <i class="el-icon-plus"></i>{{ $t('common.add') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="conditions.title" :placeholder="$t('partyActivity.search.title')" />
        </el-col>
        <el-col :span="4">
          <el-select v-model="conditions.status" :placeholder="$t('partyActivity.search.status')" style="width:100%">
            <el-option :label="$t('common.all')" value="" />
            <el-option :label="$t('partyActivity.status.notStarted')" value="0" />
            <el-option :label="$t('partyActivity.status.signing')" value="1" />
            <el-option :label="$t('partyActivity.status.ongoing')" value="2" />
            <el-option :label="$t('partyActivity.status.finished')" value="3" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryMethod()">{{ $t('common.search') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top:20px">
      <el-table :data="activities" border style="width:100%" v-loading="loading">
        <el-table-column prop="title" :label="$t('partyActivity.table.title')" align="center" />
        <el-table-column :label="$t('partyActivity.table.coverUrl')" align="center" width="100">
          <template slot-scope="scope">
            <el-image v-if="scope.row.coverUrl" :src="scope.row.coverUrl" style="width:60px;height:60px" fit="cover" :preview-src-list="[scope.row.coverUrl]" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="signStartTime" :label="$t('partyActivity.table.signTime')" align="center" width="160" />
        <el-table-column prop="startTime" :label="$t('partyActivity.table.activityTime')" align="center" width="160" />
        <el-table-column prop="address" :label="$t('partyActivity.table.address')" align="center" />
        <el-table-column :label="$t('partyActivity.table.status')" align="center" width="110">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row)" size="small">{{ getStatusText(scope.row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('partyActivity.table.signCount')" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.signCount || 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="280">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="_viewDetail(scope.row)">{{ $t('common.detail') }}</el-button>
              <el-button size="mini" @click="_openEditDialog(scope.row)">{{ $t('common.edit') }}</el-button>
              <el-button size="mini" type="warning" @click="_viewSignList(scope.row)">报名名单</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:15px" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total" />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" @close="_resetForm" @opened="_initInlineMap">
      <el-form :model="activityForm" :rules="formRules" ref="activityFormRef" label-width="120px" size="small">
        <el-form-item :label="$t('partyActivity.form.title')" prop="title">
          <el-input v-model="activityForm.title" :placeholder="$t('partyActivity.form.titlePlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('partyActivity.form.content')" prop="content">
          <el-input v-model="activityForm.content" type="textarea" :rows="2" :placeholder="$t('partyActivity.form.contentPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('partyActivity.form.coverUrl')" prop="coverUrl">
          <el-upload
            action=""
            :show-file-list="false"
            :before-upload="beforeUpload"
            :http-request="handleUpload"
          >
            <img v-if="activityForm.coverUrl" :src="activityForm.coverUrl" style="width:80px;height:80px;object-fit:cover" />
            <div v-else class="upload-btn">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('partyActivity.form.signStartTime')" prop="signStartTime">
              <el-date-picker v-model="activityForm.signStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('partyActivity.form.signEndTime')" prop="signEndTime">
              <el-date-picker v-model="activityForm.signEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('partyActivity.form.startTime')" prop="startTime">
              <el-date-picker v-model="activityForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('partyActivity.form.endTime')" prop="endTime">
              <el-date-picker v-model="activityForm.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item :label="$t('partyActivity.form.address')" prop="address">
              <el-input v-model="activityForm.address" :placeholder="$t('partyActivity.form.addressPlaceholder')" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('partyActivity.form.duration')" prop="duration">
              <el-input v-model="activityForm.duration" readonly :placeholder="$t('partyActivity.form.durationPlaceholder')" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('partyActivity.form.location')">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-input v-model="activityForm.longitude" :placeholder="$t('partyActivity.form.longitude')" readonly />
            </el-col>
            <el-col :span="12">
              <el-input v-model="activityForm.latitude" :placeholder="$t('partyActivity.form.latitude')" readonly />
            </el-col>
          </el-row>
          <div id="party-activity-map" style="width:100%;height:250px;margin-top:8px;border:1px solid #dcdfe6;border-radius:4px;"></div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="_submitForm">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPartyActivities, savePartyActivity, updatePartyActivity, getPartyActivity } from '@/api/party/partyActivityApi'
import { uploadFile } from '@/api/admin/advertManageApi'

export default {
  name: 'PartyActivityList',
  data() {
    return {
      loading: false,
      activities: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        title: '',
        status: ''
      },
      dialogVisible: false,
      isEdit: false,
      activityForm: {
        activityId: '',
        title: '',
        content: '',
        coverUrl: '',
        signStartTime: '',
        signEndTime: '',
        startTime: '',
        endTime: '',
        address: '',
        longitude: '',
        latitude: '',
        duration: ''
      },
      formRules: {
        title: [{ required: true, message: this.$t('partyActivity.form.titleRequired'), trigger: 'blur' }],
        coverUrl: [{ required: true, message: '请上传封面图', trigger: 'change' }],
        signStartTime: [{ required: true, message: this.$t('partyActivity.form.signStartTimeRequired'), trigger: 'change' }],
        signEndTime: [{ required: true, message: this.$t('partyActivity.form.signEndTimeRequired'), trigger: 'change' }],
        startTime: [{ required: true, message: this.$t('partyActivity.form.startTimeRequired'), trigger: 'change' }],
        endTime: [{ required: true, message: this.$t('partyActivity.form.endTimeRequired'), trigger: 'change' }],
        address: [{ required: true, message: this.$t('partyActivity.form.addressRequired'), trigger: 'blur' }]
      },
      map: null,
      marker: null
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('partyActivity.form.editTitle') : this.$t('partyActivity.form.addTitle')
    }
  },
  watch: {
    'activityForm.startTime'() {
      this._calcDuration()
    },
    'activityForm.endTime'() {
      this._calcDuration()
    }
  },
  created() {
    this._listActivities()
  },
  methods: {
    async _listActivities() {
      try {
        this.loading = true
        const params = {
          ...this.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listPartyActivities(params)
        this.activities = data || []
        this.page.total = total || 0
      } catch (error) {
        this.$message.error(this.$t('partyActivity.fetchError'))
      } finally {
        this.loading = false
      }
    },
    _queryMethod() {
      this.page.current = 1
      this._listActivities()
    },
    _openAddDialog() {
      this.isEdit = false
      this._resetForm()
      this.dialogVisible = true
    },
    async _openEditDialog(row) {
      this.isEdit = true
      try {
        const res = await getPartyActivity({ activityId: row.activityId })
        const data = res.data
        if (data) {
          // 后端返回data可能是数组，取第一个元素
          const item = Array.isArray(data) ? data[0] : data
          if (item) {
            this.activityForm = { ...this.activityForm, ...item }
          }
        }
        this.dialogVisible = true
      } catch (error) {
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    _viewDetail(row) {
      this.$router.push(`/pages/party/partyActivityDetail?activityId=${row.activityId}`)
    },
    _viewSignList(row) {
      this.$router.push(`/pages/party/partyActivityDetail?activityId=${row.activityId}`)
    },
    // 根据时间推断活动状态
    _getActivityStatus(row) {
      const now = new Date()
      const signStart = row.signStartTime ? new Date(row.signStartTime.replace(/-/g, '/')) : null
      const signEnd = row.signEndTime ? new Date(row.signEndTime.replace(/-/g, '/')) : null
      const actStart = row.startTime ? new Date(row.startTime.replace(/-/g, '/')) : null
      const actEnd = row.endTime ? new Date(row.endTime.replace(/-/g, '/')) : null
      if (signStart && now < signStart) return 'notStarted'
      if (signStart && signEnd && now >= signStart && now <= signEnd) return 'signing'
      if (signEnd && actStart && now > signEnd && now < actStart) return 'signupEnded'
      if (actStart && actEnd && now >= actStart && now <= actEnd) return 'ongoing'
      if (actEnd && now > actEnd) return 'finished'
      return 'notStarted'
    },
    getStatusText(row) {
      const statusMap = {
        notStarted: this.$t('partyActivity.status.notStarted'),
        signing: this.$t('partyActivity.status.signing'),
        signupEnded: this.$t('partyActivity.status.signupEnded'),
        ongoing: this.$t('partyActivity.status.ongoing'),
        finished: this.$t('partyActivity.status.finished')
      }
      return statusMap[this._getActivityStatus(row)] || ''
    },
    getStatusTagType(row) {
      const typeMap = {
        notStarted: 'info',
        signing: 'warning',
        signupEnded: '',
        ongoing: 'success',
        finished: 'info'
      }
      return typeMap[this._getActivityStatus(row)] || 'info'
    },
    _calcDuration() {
      const start = this.activityForm.startTime
      const end = this.activityForm.endTime
      if (start && end) {
        const startDate = new Date(start)
        const endDate = new Date(end)
        const diffMs = endDate - startDate
        if (diffMs > 0) {
          const diffHours = Math.round((diffMs / (1000 * 60 * 60)) * 10) / 10
          this.activityForm.duration = diffHours
        } else {
          this.activityForm.duration = ''
        }
      }
    },
    _resetForm() {
      this.activityForm = {
        activityId: '',
        title: '',
        content: '',
        coverUrl: '',
        signStartTime: '',
        signEndTime: '',
        startTime: '',
        endTime: '',
        address: '',
        longitude: '',
        latitude: '',
        duration: ''
      }
      if (this.$refs.activityFormRef) {
        this.$refs.activityFormRef.clearValidate()
      }
    },
    _submitForm() {
      this.$refs.activityFormRef.validate(async (valid) => {
        if (!valid) return
        if (!this.activityForm.coverUrl) {
          this.$message.warning('请上传封面图')
          return
        }
        try {
          if (this.isEdit) {
            await updatePartyActivity(this.activityForm)
          } else {
            await savePartyActivity(this.activityForm)
          }
          this.$message.success(this.$t('common.operationSuccess'))
          this.dialogVisible = false
          this._listActivities()
        } catch (error) {
          this.$message.error(this.$t('common.operationFailed'))
        }
      })
    },
    beforeUpload(file) {
      const isImage = file.type.includes('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error(this.$t('common.jpgOnly'))
      }
      if (!isLt10M) {
        this.$message.error(this.$t('common.sizeLimit'))
      }
      return isImage && isLt10M
    },
    async handleUpload({ file }) {
      try {
        const formData = new FormData()
        formData.append('uploadFile', file)
        const url = await uploadFile(formData)
        this.activityForm.coverUrl = url
      } catch (error) {
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    _initInlineMap() {
      this.$nextTick(() => {
        const L = window.L
        if (!L) {
          this.$message.error('Leaflet 未加载，请检查网络')
          return
        }

        if (this.map) {
          this.map.remove()
          this.map = null
          this.marker = null
        }

        const lng = parseFloat(this.activityForm.longitude) || 116.397428
        const lat = parseFloat(this.activityForm.latitude) || 39.90923

        this.map = L.map('party-activity-map').setView([lat, lng], 12)
        L.tileLayer('https://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}', {
          attribution: '&copy; AutoNavi'
        }).addTo(this.map)

        if (this.activityForm.longitude && this.activityForm.latitude) {
          this.marker = L.marker([lat, lng]).addTo(this.map)
        }

        this.map.on('click', (e) => {
          const { lat: clickLat, lng: clickLng } = e.latlng
          this.activityForm.latitude = clickLat.toFixed(6)
          this.activityForm.longitude = clickLng.toFixed(6)
          if (this.marker) {
            this.marker.setLatLng([clickLat, clickLng])
          } else {
            this.marker = L.marker([clickLat, clickLng]).addTo(this.map)
          }
        })
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listActivities()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listActivities()
    }
  }
}
</script>

<style lang="scss" scoped>
.party-activity-container {
  padding: 20px;

  .upload-btn {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    background-color: #fbfdff;

    &:hover {
      border-color: #409eff;
    }

    i {
      font-size: 24px;
      color: #8c939d;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 12px;
  }

  ::v-deep .el-form-item__label {
    font-size: 13px;
  }

  ::v-deep .el-dialog__body {
    padding: 15px 20px;
  }
}
</style>
